module.exports = __webpack_public_path__ + "56e649039de72873e3700bcc05d6d62c.svg";